<template>
	<div>
		<van-nav-bar title="关键词踢人设置" left-text="返回" left-arrow fixed placeholder @click-left="onClickLeft" v-show="this.$UserAgent.indexOf('Html5Plus')==-1?true:false" />
		<van-form @submit="onSubmit">

			<van-field name="switch_checked" label="功能总开关">
				<template #input>
					<van-switch v-model="switch_checked" size="20" />
				</template>
			</van-field>
			
			<van-field v-model="keyword" name="keyword" label="违规关键词:" ref="keyword" type="textarea" placeholder="请输入违规关键词,使用[ / ]隔开" :rules="[{ required: true, message: '多个关键词使用[ / ]斜线隔开' }]"
			 maxlength="50" show-word-limit />

			<div style="margin-left: 0.2rem;">
				<van-tag @click="addKw" mark v-if="keyword!=''"  type="primary" plain  >点我再添加一个违规关键词</van-tag>
				<p style="font-size: 10px;font-weight: bold;color: #1989fa;">设置多个关键词需要使用斜线[ / ]隔开，比如:词1/词2</p>
			</div>
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">
					提交
				</van-button>
			</div>
		</van-form>
	</div>


</template>

<script>
	import Vue from 'vue';
	import {
		Tag
	} from 'vant';

	Vue.use(Tag);
	export default {
		data() {
			return {
				group_id: 0,
				switch_checked: false,
				op: 'akeyword',

				keyword: '',

			}
		},
		created() {
			var group_id = localStorage.getItem('select_id')
			if (!group_id) {
				this.$router.push('/member-center')
				return;
			}
			this.group_id = group_id

			this.$ApiUtil.GroupCenterSrc.get({
				a: group_id,
				v: this.op
			}).then(res => {
				if (res.status) {
					this.switch_checked = res.data.switch_checked
					this.keyword = res.data.keyword
				}
			})
		},
		methods: {
			addKw(){
				this.$refs.keyword.focus()
				if(this.keyword.substring(this.keyword.length - 1) == '/') return
				this.keyword = this.keyword + '/';
				
			},
			onClickLeft() {
				this.$router.back()
			},
			onSubmit(values) {
				this.$ApiUtil.GroupCenterSrc.post({
					op: this.op,
					id: this.group_id,
					values: JSON.stringify(values)
				}).then(res => {
					if (!res.status) {
						this.$toast.fail(res.message)
						return
					}
					this.$toast.success('已保存')
				})
			},
		}
	}
</script>

<style>
</style>
